<script setup lang="ts">
import { ref } from 'vue';
const props = defineProps<{ modelValue: string; apartments: string[] }>();
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();
const menu = ref<globalThis.HTMLDetailsElement | null>(null);
const trigger = ref<globalThis.HTMLElement | null>(null);
function close(): void {
  if (menu.value) menu.value.open = false;
  trigger.value?.focus();
}
function select(apartment: string): void {
  if (!props.apartments.includes(apartment)) return;
  emit('update:modelValue', apartment);
  close();
}
</script>

<template>
  <div class="apartment-picker">
    <span id="delivery-apartment-label">Votre logement</span>
    <details ref="menu" @keydown.esc.prevent.stop="close">
      <summary
        id="delivery-apartment-name"
        ref="trigger"
        aria-labelledby="delivery-apartment-label delivery-apartment-selected"
      >
        <span id="delivery-apartment-selected">{{
          modelValue || 'Choisissez votre logement'
        }}</span>
      </summary>
      <ul aria-label="Logements disponibles">
        <li v-for="apartment in apartments" :key="apartment">
          <button
            type="button"
            :aria-pressed="modelValue === apartment"
            @click="select(apartment)"
          >
            {{ apartment }}
          </button>
        </li>
      </ul>
    </details>
  </div>
</template>

<style scoped>
.apartment-picker {
  min-width: 0;
}
details {
  margin: 0.5rem 0 1rem;
  border: 1px solid #64748b;
  border-radius: 12px;
  background: #fff;
  color: #172033;
  overflow: hidden;
}
summary {
  padding: 0.85rem;
  min-height: 48px;
  box-sizing: border-box;
  cursor: pointer;
  overflow-wrap: anywhere;
}
ul {
  list-style: none;
  padding: 0.4rem;
  margin: 0;
  max-height: 16rem;
  overflow-y: auto;
  border-top: 1px solid #dbe2ea;
}
li {
  margin: 0;
}
button {
  width: 100%;
  min-height: 48px;
  padding: 0.85rem;
  border: 0;
  border-radius: 8px;
  background: #fff;
  color: #172033;
  text-align: left;
  font: inherit;
  overflow-wrap: anywhere;
}
button[aria-pressed='true'],
button:hover {
  background: #e8eef9;
  color: #163b78;
}
summary:focus-visible,
button:focus-visible {
  outline: 3px solid #1d4ed8;
  outline-offset: -3px;
}
</style>
